module.exports = __webpack_public_path__ + "static/terra-mattress-4-927ce4277166e4b6c3ef65b5eb643e1c.webp";